export const SEARCH = 'search';
export const SELLER_ID = 'seller_id';
export const STORE_ID = 'store_id';
export const BANK_CODE = 'bank_code';
export const SORT = 'sort';
